/**
 * Décide s'il faut recaler la lecture d'un evergreen sur l'avancement réel de la session, et où.
 *
 * Nécessaire parce que `controls={false}` ne suffit pas : en plein écran natif WebKit (Safari macOS,
 * iPhone) et en mini-fenêtre, le navigateur réaffiche ses propres contrôles, barre de progression
 * comprise. Le spectateur peut alors avancer jusqu'à la fin et sauter offres et sondages, tous
 * pilotés par l'avancement de la session.
 */

/** Écart toléré entre la lecture et l'avancement réel de la session avant recalage. */
export const EVERGREEN_SEEK_TOLERANCE_S = 3;

/** Marge gardée avant la fin du média : se poser pile sur `duration` déclenche `ended`. */
export const EVERGREEN_END_MARGIN_S = 0.25;

/** Position cible d'un evergreen à un instant donné de la session, bornée par la durée du média. */
export function clampEvergreenPosition(expectedTime: number, duration: number): number {
  const floored = Math.max(0, expectedTime);
  if (!Number.isFinite(duration) || duration <= 0) return floored;
  return Math.min(floored, Math.max(0, duration - EVERGREEN_END_MARGIN_S));
}

/**
 * Position à imposer à un evergreen, ou `null` s'il est là où il doit être.
 * `expectedTime` = secondes écoulées depuis le début de la session.
 */
export function resolveEvergreenSeekCorrection(params: {
  currentTime: number;
  expectedTime: number;
  duration: number;
  toleranceSeconds?: number;
}): number | null {
  const { currentTime, expectedTime, duration } = params;
  const tolerance = params.toleranceSeconds ?? EVERGREEN_SEEK_TOLERANCE_S;
  if (!Number.isFinite(currentTime) || !Number.isFinite(expectedTime)) return null;

  const target = clampEvergreenPosition(expectedTime, duration);
  if (Math.abs(currentTime - target) <= tolerance) return null;
  return target;
}
